import { Language, QUERY_KEYS } from "@cnx/common";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import i18n, { supportedLanguages } from "common/i18n";
import LanguageService from "services/LanguageService";
import UserService from "services/UserService";
import { selectNationalFlag } from "utils/flags";

export const useLanguages = () => {
  const { data, isPending, isSuccess, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.LANGUAGES],

    queryFn: async () => {
      const languages = await LanguageService.getLanguages();

      return languages;
    },
  });

  const languageMap = new Map<string, Language>();
  data?.forEach(language => languageMap.set(language.key, language));

  return {
    languageMap,
    languages: data ?? [],
    isPending,
    isFetching,
    isSuccess,
  };
};

export const useLanguageChooser = (currentLanguage = i18n.language) => {
  const { languages } = useLanguages();
  const queryClient = useQueryClient();

  const handleLanguageChange = async (language: string | null) => {
    if (!language) return;

    i18n.changeLanguage(language);

    try {
      UserService.setUserLanguage(language);
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.NOTIFICATIONS],
      });
    } catch (error) {
      console.error(error);
    }
  };

  const options = languages.map(language => ({
    value: language.key,
    label: language.name,
    disabled: !supportedLanguages.includes(language.key),
  }));

  return {
    handleLanguageChange,
    options,
    nationalFlag: selectNationalFlag(currentLanguage),
    language: currentLanguage,
  };
};
